import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";

import {
  faFacebookF,
  faXTwitter,
  faInstagram,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";

const SubNav = () => {
  return (
    <div className="flex justify-between items-center bg-[#012B54] md:px-10 px-4  py-2 w-full">
      <div className="flex gap-4 items-center">
        {/* Left Section: Mobile number and email */}
        <a
          href="https://wa.me/919717055088"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1"
        >
          <FontAwesomeIcon icon={faPhone} className="text-white" />
          <span className="text-white text-xs md:text-sm">+91 9717055088</span>
        </a>

        <a
          href="mailto:info@deetyasoft.com"
          className="md:flex hidden items-center"
        >
          <FontAwesomeIcon icon={faEnvelope} className="text-white pr-1" />
          <span className="text-white text-xs md:text-sm">
            info@deetyasoft.com
          </span>
        </a>
      </div>

      {/* Right Section: Social media icons */}

      <div className="flex md:space-x-2 space-x-[2px]">
        <a
          href="https://www.facebook.com/share/1VNnHxXpD7/"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-7 h-7 rounded-full transition duration-200 bg-white text-blue-400"
        >
          <FontAwesomeIcon icon={faFacebookF} className="text-sm" />
        </a>
        <a
          href="https://x.com/DeetyaSoft"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-7 h-7 rounded-full transition duration-200 bg-white text-black"
        >
          <FontAwesomeIcon icon={faXTwitter} className="text-sm" />
        </a>
        <a
          href="https://www.linkedin.com/company/deetya-soft-private-limited/"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-7 h-7 rounded-full transition duration-200 bg-white text-blue-500"
        >
          <FontAwesomeIcon icon={faLinkedinIn} className="text-sm" />
        </a>
        <a
          href="https://www.instagram.com/deetyasoft?igsh=MWxrNWNtaTNhdHFlag=="
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-7 h-7 rounded-full transition duration-200 bg-white  text-pink "
        >
          <FontAwesomeIcon icon={faInstagram} className="text-sm" />
        </a>
      </div>
    </div>
  );
};

export default SubNav;
